(function() {
'use strict';

angular
    .module('TR')
    .controller('Occupancy', Occupancy);

function Occupancy($window, occupancyService, arrayUtil, $route) {
    const cm = this;
    const area = $route.current.area;

    cm.adultRange = occupancyService.adultRange(area);
    cm.ages = occupancyService.ages;
    cm.applyOccupancy = occupancyService.applyOccupancy;
    cm.childRange = occupancyService.childRange(area);
    cm.childrenChanged = childrenChanged;
    cm.maxAge = area === 'marhaba' ? 12 : 17;
    cm.occupancyAgeConfig = {
        Min: 0,
        Max: cm.maxAge
    };

    cm.addRoom = addRoom;
    cm.removeRoom = removeRoom;
    cm.showRoom = showRoom;
    cm.isActive = isActive;
    cm.occupancy = occupancyService.getOccupancy();
    cm.passengerCount = occupancyService.getPassengerCount();

    //if this is transfers / marhaba / insurance occupancy then rooms don't make sense and we need to merge the occupancy into one room
    if (area === 'transfers' || area === 'marhaba' || area === 'insurance' || area === 'flights') {
        cm.occupancy = [occupancyService.reduceOccupancy()];
    }

    cm.currentRoom = cm.occupancy[0];

    _countChildren();

    occupancyService.onApplyOccupancy(function() {
        setTimeout(function() {
            occupancyService.setOccupancy(cm.occupancy);
            occupancyService.setPassengerCount(cm.passengerCount);
            $window.history.back();
        }, 0);
    });

    function isActive(room) {
        return room === cm.currentRoom ? 'active' : '';
    }

    function childrenChanged() {
        arrayUtil.addOrRemove(cm.currentRoom.ChildAges, cm.currentRoom.numChildren, function() {
            // Default child age
            return 8;
        });
    }

    function addRoom() {
        cm.occupancy = occupancyService.addRoom();
        cm.currentRoom = cm.occupancy[cm.occupancy.length - 1];
        _countChildren();
    }

    function removeRoom(index) {
        cm.occupancy = occupancyService.removeRoom(index);
        cm.currentRoom = cm.occupancy[cm.occupancy.length - 1];
    }

    function showRoom(index) {
        cm.currentRoom = cm.occupancy[index];
    }

    function _countChildren() {
        cm.occupancy.forEach(function(o) {
            o.numChildren = (o.ChildAges || []).length;
        });
    }
}
})();
